// import { a } from "../Components/Panel/Panel.tsx";

import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { isAdminLoggedIn } from '../Components/Panel/Panel/index';
import { aAppdef, aAppVlue } from '../App';
import { t } from 'i18next';

// import { abc } from "../Components/Panel/Panel";

export function extractCurrentAccount(e: any, shop_url?: string | null) {

    let user_account: any = {
        source: {
            shopify: [],
        },
        target: {
            amazon: [],
        },
    };

    let source = extractCurrentSourceShop(e, shop_url);
    if (process.env.REACT_APP_PROD === "0" || isAdminLoggedIn()) {
        user_account['allsource'] = extractSourceShop(e);
    }
    // user_account['source'] = source;
    if (Object.keys(source).length > 1) {
        user_account['source']['shopify'] = [source];
        user_account['target'] = exportCurrentTargetShop(
            e,
            user_account['source']['shopify'][0]['_id']
        );
    }
    return user_account;
}

function getTimeStamp30secBefore(unixtime: any) {
    let time = unixtime / 1000;
    time = time - 30;
    return time * 1000;
}

function getCurrentGmtUnixTime() {
    let t = new Date();
    let str = `${t.getUTCFullYear()}-${t.getUTCMonth() + 1
        }-${t.getUTCDate()} ${t.getUTCHours()}:${t.getUTCMinutes()}:${t.getUTCSeconds()}`;
    return Date.parse(str);
}

export function extractCurrentSelected(
    props: any,
    e: any,
    shop_url?: string | null,
    updateCurrentShop: boolean = false,
    dispacher?: ThunkDispatch<any, unknown, Action<string>>,
    showToast: boolean = true
) {
    const current: any = {
        source: extractCurrentSourceShop(e, shop_url),
        target: {},
    };
    let target_id: any = null;
    if (props.di.globalState.get('target_id')) {
        target_id = props.di.globalState.get('target_id');
    }
    props.di.globalState.set('source_id', current['source']['_id']);
    let orignalTarget: any = props?.redux?.account?.target ?? {};
    const target = exportCurrentTargetShop(e, current['source']['_id']);

    let cc: any[] = target['amazon'];
    let dd: any[] = orignalTarget['amazon'];

    if (Object.keys(target).length > 0) {
        if (Object.values(target[Object.keys(target)[0]]).length > 0) {
            Object.values(target[Object.keys(target)[0]]).map((tAcc: any) => {
                if (tAcc['_id'] == target_id) {
                    current['target'] = tAcc;
                }
            });

            if (!target_id || Object.keys(current['target']).length == 0) {
                current['target'] = Object.values(
                    target[Object.keys(target)[0]]
                )[0];
                if (isAdminLoggedIn()
                    // || process.env.REACT_APP_PROD == "0"
                ) {
                    props.di.globalState.set('target_id', current['target']['_id']);
                    props.history('loading');
                    props.history(-1);
                    dispacher && dispacher({
                        type: 'onBoarding',
                        state: {
                            'step_status': '_INPROGRESS_'
                        },
                    });
                }
                aAppVlue.changeTarget &&
                    aAppVlue.changeTarget(
                        props,
                        current['target']['_id'],
                        dispacher
                    );
            }
            if (updateCurrentShop) {
                if (dd?.length != cc?.length) {
                    current['target'] = Object.values(
                        target[Object.keys(target)[0]]
                    )[Object.values(target[Object.keys(target)[0]]).length - 1];
                    props.di.globalState.set(
                        'target_id',
                        current['target']['_id']
                    );
                    // props.history(-1);
                    props.history('../config');
                    dispacher &&
                        dispacher({
                            type: 'onBoarding',
                            state: {
                                step_status: '_INPROGRESS_',
                            },
                        });

                    showToast && props.success('Account connected successfully!');
                } else {
                    let reconnected = false;
                    let timeToCheck = getTimeStamp30secBefore(
                        getCurrentGmtUnixTime()
                    );
                    Object.values(target[Object.keys(target)[0]]).forEach(
                        (ele: any) => {
                            let loginTime = Date.parse(
                                ele?.last_login_at ?? ''
                            );
                            if (timeToCheck <= loginTime) {
                                reconnected = true;
                            }
                        }
                    );
                    if (reconnected) {
                        props.success('Account Already Connected');
                    } else {
                        props.error(t('Connection unsuccessful!'));
                        dispacher &&
                            dispacher({
                                type: 'onBoarding',
                                state: {
                                    step_status: '_FAILED_',
                                },
                            });
                    }
                }
            }
        }
    }

    return current;
}

function exportCurrentTargetShop(e: any, shop_id?: any) {

    let user_account_new: any = {
        target: {
            amazon: [],
        },
    };
    Object.values(e.data)
        .filter(
            (code: any) =>
                // code.code === 'mercado_cbt' ||
                code.is_target == 1 || code.is_source == 1
        )
        .filter(
            (code: any) =>
                typeof code.installed === 'object' &&
                Object.keys(code.installed).length > 0
        )
        .forEach((account: any) => {
            Object.values(account.installed).forEach((acc: any) => {
                // check using shopify data
                if (Object.keys(acc.sources ?? {}).length > 0) {
                    Object.values(acc.sources).forEach((acc2: any) => {
                        // check using shopify data
                        if (!(isAdminLoggedIn()
                            // || process.env.REACT_APP_PROD == "0"
                        )) {
                            if (acc2?.shop_id == shop_id && !acc2?.disconnected) {
                                user_account_new['target'][acc.marketplace].push(
                                    acc
                                );
                            }
                        }
                        else {
                            if (acc2?.shop_id == shop_id) {
                                user_account_new['target'][acc.marketplace].push(
                                    acc
                                );
                            }
                        }
                    });
                }
            });
        });
    return user_account_new['target'];
}
export function extractSourceShop(e: any) {
    let accountShop: any = {};
    Object.values(e.data)
        .filter(
            (code: any) =>
                typeof code.installed === 'object' &&
                Object.keys(code.installed).length > 0
        )
        .forEach((account: any) => {
            Object.values(account.installed).forEach((acc: any) => {
                // check using shopify data
                if (account.is_source == 1) {
                    if (!accountShop[acc['marketplace']]) {
                        accountShop[acc['marketplace']] = [];
                    }
                    accountShop[acc['marketplace']].push(acc);
                }
            });
        });

    return accountShop;
}
export function extractCurrentSourceShop(e: any, shop_url?: string | null) {
    let currentAccountShop: any = {};
    Object.values(e.data)
        .filter(
            (code: any) =>
                typeof code.installed === 'object' &&
                Object.keys(code.installed).length > 0
        )
        .forEach((account: any) => {
            Object.values(account.installed).forEach((acc: any) => {
                // check using shopify data
                if (acc.myshopify_domain === shop_url) {
                    currentAccountShop = acc;
                }
            });
        });
    return currentAccountShop;

    return {
        [currentAccountShop['marketplace']]: [currentAccountShop],
    };
}